import { useState } from "react";
import { PartnerModal } from "../components/common";
import {
  HeroSection,
  StatsRibbon,
  CompanyMentorsMarquee,
  CountriesMarquee,
  EcosystemPipeline,
  VenturesSection,
  VisionSection,
  PartnersSection,
} from "../components/home";

export default function HomePage() {
  const [partnerOpen, setPartnerOpen] = useState(false);

  return (
    <>
      <HeroSection />
      <StatsRibbon />
      <CompanyMentorsMarquee />
      <EcosystemPipeline />
      <VenturesSection />
      <CountriesMarquee />
      <VisionSection />
      <PartnersSection onPartnerClick={() => setPartnerOpen(true)} />
      <PartnerModal open={partnerOpen} onOpenChange={setPartnerOpen} />
    </>
  );
}
